import { useEffect } from "react";
import { navigate } from "@reach/router";
import Profile from "./Profile";
import { useFeatureFlagEnabled } from "src/hooks/useFeatureFlagEnabled";
import { PROFILE_STATS_FLAG } from "src/featureFlags";

type Props = {
  path: string;
};

/**
 * Feature-flag gate for the `/profile` route.
 *
 * When the Profile & Stats flag is OFF (the default, and the state for any
 * unresolved/loading/blocked PostHog) the route is not navigable: it redirects
 * to `/` with a replace so it does not pollute history, and renders nothing in
 * the meantime. This also blocks direct-URL access. When the flag is ON it
 * renders the real Profile page. Mirrors the nav-link gating in AppMenu so the
 * menu and the route can never diverge.
 */
const ProfileRoute = ({ path }: Props): React.ReactNode => {
  const enabled = useFeatureFlagEnabled(PROFILE_STATS_FLAG);

  useEffect(() => {
    if (!enabled) navigate("/", { replace: true });
  }, [enabled]);

  return enabled ? <Profile path={path} /> : null;
};

export default ProfileRoute;
